import { Component } from '@angular/core';

@Component({
  selector: 'app-svg-delivery',
  styleUrls: ['./delivery.component.scss'],
  templateUrl: './delivery.component.html'
})
export class DeliveryComponent {}
